import React, { useState } from 'react';
import HyperModal, { ModalStack } from 'react-hyper-modal';
import Gist from '../../components/Gist';
import BaseLayout from '../../components/BaseLayout';
import Button from '../../components/Button';
import HeaderText from '../../components/HeaderText';
import './style.scss';

const HyperModalComponent = () => {
  const [isModalOpen, setModalOpen] = useState(false)
  const [index, setIndex] = useState(0)
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  return (
    <BaseLayout
      className="example-hyper-modal-wrapper"
      title="react hyper modal"
      link="https://github.com/alekseymakhankov/hyper-modal"
    >
      <div className="content">
        <HeaderText title="Stackable modal content" />
        <Gist
          id="965ebd30f423f14ac342ba6be07fe54b"
          file="react-hyper-modal-stackable-example.jsx"
        />
        <HyperModal
          classes={{
            contentClassName: 'modal-content',
          }}
          stackable
          stackableIndex={index}
          renderOpenButton={(requestOpen) => {
            return (
              <Button
                onClick={requestOpen}
                title="open stackable modal"
                position="center"
                wide
              />
            )
          }}
        >
          {props => (
            <ModalStack {...props} className="stackable-wrapper">
              <div className="stackable-item">
                <div>root content</div>
                <Button
                  onClick={() => setIndex(1)}
                  title="next level"
                  position="center"
                  wide
                />
              </div>
              <div className="stackable-item">
                <div>the second level</div>
                <Button
                  onClick={() => setIndex(0)}
                  title="prev level"
                  position="center"
                  wide
                />
                <Button
                  onClick={() => setIndex(2)}
                  title="next level"
                  position="center"
                  wide
                />
              </div>
              <div className="stackable-item">
                <div>the third level</div>
                <Button
                  onClick={() => setIndex(1)}
                  title="prev level"
                  position="center"
                  wide
                />
              </div>
            </ModalStack>
          )}
        </HyperModal>


        <HyperModal
          isOpen={isModalOpen}
          requestClose={closeModal}
          classes={{
            contentClassName: 'modal-content',
          }}
        />
        <HeaderText title="Simple controlled modal" />
        <Gist
          id="965ebd30f423f14ac342ba6be07fe54b"
          file="react-hyper-modal-simple-example.jsx"
        />
        <Button
          onClick={openModal}
          title="open simple modal"
          position="center"
          wide
        />

        <HeaderText title="Uncontrolled modal" />
        <Gist
          id="965ebd30f423f14ac342ba6be07fe54b"
          file="react-hyper-modal-uncontrolled-example.jsx"
        />
        <HyperModal
          classes={{
            contentClassName: 'modal-content',
          }}
          renderOpenButton={(requestOpen) => {
            return (
              <Button
                onClick={requestOpen}
                title="open uncontrolled modal"
                position="center"
                wide
              />
            )
          }}
        />

        <HeaderText title="Uncontrolled modal with default button" />
        <Gist
          id="965ebd30f423f14ac342ba6be07fe54b"
          file="react-hyper-modal-default-button-example.jsx"
        />
        <HyperModal
          classes={{
            contentClassName: 'modal-content',
          }}
          renderOpenButton
        />

        <HeaderText title="Custom modal content" />
        <Gist
          id="965ebd30f423f14ac342ba6be07fe54b"
          file="react-hyper-modal-custom-content-example.jsx"
        />
        <HyperModal
          classes={{
            contentClassName: 'modal-content',
          }}
          renderOpenButton={(requestOpen) => {
            return (
              <Button
                onClick={requestOpen}
                title="open modal"
                position="center"
                wide
              />
            )
          }}
        >
          <div>
            Your awesome modal content
            </div>
        </HyperModal>

        <HeaderText title="Fullscreen modal" />
        <Gist
          id="965ebd30f423f14ac342ba6be07fe54b"
          file="react-hyper-modal-fullscreen-example.jsx"
        />
        <HyperModal
          classes={{
            contentClassName: 'modal-fullscreen',
            wrapperClassName: 'wrapper-modal',
            dimmerClassName: 'dimmer-modal'
          }}
          isFullscreen
          renderOpenButton={(requestOpen) => {
            return (
              <Button
                onClick={requestOpen}
                title="open fullscreen modal"
                position="center"
                wide
              />
            )
          }}
        />
      </div>
    </BaseLayout>
  );
}

export default HyperModalComponent;
